import axios from 'axios';

import { notify } from './utils';

// fetch vesting calendars
export const fetch_vesting_calendars = async (): Promise<any> => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API}/vestingCalendars.php`,
      params: {
        process: 'list',
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
    if (response && response.data && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    return false;
  }
};

// add vesting calendar
export const add_vesting_calendar = async (
  data: VestingCalendarObject,
  func?: any,
): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/vestingCalendars.php`,
      params: {
        process: 'add',
        data: data,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

// update vesting calendar
export const update_vesting_calendar = async (
  id: number,
  data: VestingCalendarObject,
  func?: any,
): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/vestingCalendars.php`,
      params: {
        process: 'update',
        id: id,
        data: data,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

// remove vesting calendar
export const remove_vesting_calendar = async (id: number, func?: any): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/vestingCalendars.php`,
      params: {
        process: 'delete',
        id: id,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    return true;
  } catch (error) {
    return false;
  }
};

// fetch favorite wallets
export const fetch_favorite_wallets = async (): Promise<any> => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API}/wallets.php`,
      params: {
        process: 'list',
        type: 'Favorite',
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
    if (response && response.data && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    return false;
  }
};

// add favorite wallet
export const add_favorite_wallet = async (
  address: string,
  name: string,
  func?: any,
): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/wallets.php`,
      params: {
        process: 'add',
        type: 'Favorite',
        address: address,
        name: name,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    return true;
  } catch (error) {
    return false;
  }
};

// remove favorite wallet
export const remove_favorite_wallet = async (id: number, func?: any): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/wallets.php`,
      params: {
        process: 'delete',
        id: id,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    return true;
  } catch (error) {
    return false;
  }
};

// fetch favorite tokens
export const fetch_favorite_tokens = async (): Promise<any> => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API}/tokens.php`,
      params: {
        process: 'list',
        type: 'Favorite',
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
    if (response && response.data && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    return false;
  }
};

// add favorite token
export const add_favorite_token = async (coingeckoid: string, func?: any): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/tokens.php`,
      params: {
        process: 'add',
        type: 'Favorite',
        coingeckoid: coingeckoid,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    notify('Token added to favorites.');

    return true;
  } catch (error) {
    return false;
  }
};

// remove favorite token
export const remove_favorite_token = async (id: number, func?: any): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/tokens.php`,
      params: {
        process: 'delete',
        id: id,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    notify('Token removed from favorites.');

    return true;
  } catch (error) {
    return false;
  }
};

// fetch favorite whales
export const fetch_favorite_whales = async (): Promise<any> => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API}/tokens.php`,
      params: {
        process: 'list',
        type: 'Whale',
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });
    if (response && response.data && response.data.data) {
      return response.data.data;
    }
  } catch (error) {
    return false;
  }
};

// add favorite whale
export const add_favorite_whale = async (coingeckoid: string, func?: any): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/tokens.php`,
      params: {
        process: 'add',
        type: 'Whale',
        coingeckoid: coingeckoid,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    notify('Token added to whales.');

    return true;
  } catch (error) {
    return false;
  }
};

// remove favorite whale
export const remove_favorite_whale = async (id: number, func?: any): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/tokens.php`,
      params: {
        process: 'delete',
        id: id,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    notify('Token removed from whales.');

    return true;
  } catch (error) {
    return false;
  }
};

// add reminder token
export const add_reminder_token = async (
  coingeckoid: string,
  finalPrice: string,
  kind: string,
  func?: any,
): Promise<boolean> => {
  try {
    await axios({
      url: `${process.env.REACT_APP_API}/reminders.php`,
      params: {
        process: 'add',
        type: 'Portfolio',
        finalPrice: finalPrice,
        kind: kind,
        coingeckoid: coingeckoid,
      },
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    });

    if (func) {
      func(false);
    }

    notify('Token added to reminders.');

    return true;
  } catch (error) {
    return false;
  }
};

// fetch favorite tokens
export const fetch_reminder_ens = async (): Promise<any> => {};

// add favorite token
export const add_reminder_ens = async (coingeckoid: string, func?: any): Promise<boolean> => {
  try {
    if (func) {
      func(false);
    }

    notify('ENS added to reminders.');

    return true;
  } catch (error) {
    return false;
  }
};

// remove favorite token
export const remove_reminder_ens = async (id: number, func?: any): Promise<boolean> => {
  try {
    if (func) {
      func(false);
    }

    notify('ENS removed from reminders.');

    return true;
  } catch (error) {
    return false;
  }
};
